import React from "react";

const EmptyPage = () => {
  return <div data-testid="workspace-empty"></div>;
};

export default EmptyPage;
